export default (online, available) => {
  if (online === 'Online') {
    return available ? 'Online' : 'Unavailable';
  }
  return 'Offline';
};
